export const EDIT_EMPLOYEES = 'employeeList/editEmployees'
export const EDIT_JOBS = 'employeeList/editJobs'
export const SEARCH_FLOORPLAN = 'floorplan/searchFloorplan'